export const STATICCODESERVICE = {
    IDENTIFICATION_TYPE_MYKAD: "MYKAD",
    IDENTIFICATION_TYPE_MYKID: "MYKID",
    GENDER_MASTER_MALE: "MALE",
    GENDER_MASTER_FEMALE: "FEMALE",
    COUNTRY_MALAYSIA: "MYS",
    OTHERS: "OTHERS"
}